import { render, staticRenderFns } from "./PackageSummaryMobile.vue?vue&type=template&id=349f3c3f"
import script from "./PackageSummaryMobile.vue?vue&type=script&lang=ts"
export * from "./PackageSummaryMobile.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports